<template>
  <div>

  <v-container fluid class="bg-black" grid-list-sm>
    <v-layout>
                  <v-flex xs12 justif-center>
               <div class="team-numbers__presentation">
                    <h2 class="team-numbers__presentation--title">{{ title }}</h2>
                    <h6 class="team-numbers__presentation--subtitle">{{ subtitle }}</h6>
                    <br>
                    <v-btn outline color="#004f6b" :to="{name: 'sponsors'}">{{ linkPartners }}</v-btn>
                    <v-btn color="#004f6b" class="text-light" :to="{name: 'partenariat'}">{{ linkBecomePartner }}</v-btn>
                    <p></p>
                </div>
            </v-flex>
    </v-layout>
    <v-layout row wrap justify-center>
      <v-flex xs12 sm6 md3 lg3 xl2 v-for="item in partnersData" :key="item.id" >
          <div class="text-xs-center" >
            <img class="item-img" :src="item.acf.logo" height="100px" width="250" :alt="'Image partenaire - ' + item.acf.nom" />
          </div>
      </v-flex>
    </v-layout>

  </v-container>
  </div>
</template>

<script>
import axios from 'axios';
import {_} from 'underscore';

import RestApiHelper from "../../../helpers/rest-api-func.js";
import { RestPageIdx, RestCustomPosts, WP_API_ACF_ROOT_URL, WP_API_WP_ROOT_URL } from '../../../helpers/rest-api-addr.js';

export default {
  data() {
    return {
      partnersData: [],
      isLoading : false,
    };
  },
  props: {
    title: {
      type: String,
      default:"Ils soutiennent le BOP"
    },
    subtitle: {
      type : String,
      default: "Nos partenaires et sponsors"
    },
    linkPartners: {
      type : String,
      default: "Voir tous les partenaires"
    },
    linkBecomePartner: {
      type: String,
      default: "Devenir partenaire"
    },
    partnersIds: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  mounted() {
    this.debouncedLoad = _.debounce(this.loadLinks, 500, true);
    this.loadLinks();
  },
  watch: {
    partnersIds: function(newIds, oldIds) {
        this.partnersIds = newIds;
        this.debouncedLoad();
    }
  },
  methods: {
    setData(data, isLoading) {
      this.partnersData = data;
      this.$nextTick(function() {
        this.isLoading = isLoading;
      });
    },
    loadLinks() {
      if(this.partnersIds && this.partnersIds.length > 0) {
        this.partnersData = [];
        this.isLoading = true;
        RestApiHelper.requestCustomPostData(WP_API_WP_ROOT_URL, RestCustomPosts.sponsors.rest_name, this.partnersIds)
        .then(r_data => {
          this.setData(r_data.data, false);
        })
        .catch(error => {
          this.setData([], false);
        })
      }
    }
  }
};
</script>

<style lang="scss">
.item-img {
  object-fit: contain;
  margin-bottom: 2rem;
}
.bg-black {
  background-color:#F4F4F4 ;
}

.team-numbers {
  &__presentation {
    position: relative;
    margin-top: 3.5rem;
    margin-bottom: 6rem;
    text-align: center;

    &--title {
      position: relative;
      display: inline-block;
      color: #333;
      // color: white;
      font-size: 3rem;
      letter-spacing: 3.5px;
      font-weight: 500;
      text-transform: uppercase;
      width:"auto";
      height: "auto";
      margin-bottom: 30px;

      &::before {
        content:" ";
        display: block;
        position: absolute;
        height: 4px;
        width: 30%;
        background-color: darken(#05bdff, 30%);
        bottom: -10px;
        left: 50%;
        transform: translate(-50%);

      }

      &.color--light {
        color: #eee;
      }

      //&.color--light::before {
        // background-color: #ddd;
      //}
    }

    &--subtitle {
      color: grey;
      font-weight: 400;
      font-size: 1.4rem;
      text-transform: uppercase;

      &.color--light {
        color: #eef;
      }
    }

  } // __presentation

  &__numbers-item {
    & .number {
      &__wrapper{
        position: relative;
        display: inline-block;
        border-radius: 100%;
        width: 7rem;
        height: 7rem;
        background-color: darken(#05bdff, 38%);
        box-sizing: content-box;
      }

      &__content {
        position: absolute;
        display: inline-block;
        font-size: 4.5rem;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        transition: all 0.2s;
        color: white;
        font-weight: 500;
        font-family: 'Lato', Arial, Helvetica, sans-serif;


        //&:hover {

        //}
      }
    } // .numbers

    & .desc {
      &__wrapper{
        padding-left: 20px;
        padding-right: 20px;
      }
      &__title{
        margin-top: 1rem;
        font-weight: 400;
        text-transform: capitalize;
        color: darken(#05bdff, 38%);
      }
      &__details {
        word-break: break-word;
        word-wrap: break-word;
        color: #888;
        // font-style: italic;


      }
    }  // .desc
  } // __numbers-item
}
// ----------------------------------
$carouselImgLen: 250px;

@mixin white-gradient {
	background: linear-gradient(to right,  rgba(255,255,255,1) 0%,rgba(255,255,255,0) 100%);
}

$animationSpeed: 20s; // 30s

// Animation
@keyframes scroll {
	0% { transform: translateX(0); }
	100% { transform: translateX(calc(-250px * 9))}
  // 0% { transform: translateX(calc(-250px * 0)); }
  // 50% { transform: translateX(calc(-250px * 0)); }
  // 51% { transform: translateX(calc(-250px * 4)); }
  // 99% { transform: translateX(calc(-250px * 4)); }
  // 100% { transform: translateX(calc(-250px * 0)); }
}


// Styling
.slider {
  position: relative;
	background: white;
	// box-shadow: 0 10px 20px -5px rgba(0, 0, 0, .125);
	height: 150px;
	margin: auto;
	overflow:hidden;
	position: relative;
	width: 960px;
  padding-top: 25px;
  padding-bottom: 25px;
  margin-top: -25px;


	&::before,
	&::after {
		// @include white-gradient;
		content: "";
		height: 100px;
		position: absolute;
		width: 200px;
		z-index: 2;
	}

	&::after {
		right: 0;
		top: 0;
		transform: rotateZ(180deg);
	}

	&::before {
		left: 0;
		top: 0;
	}

	.slide-track {
		animation: scroll $animationSpeed linear infinite;
		display: flex;
		width: calc($carouselImgLen * 4); // * 13
	}

	.slide {
		height: 100px;
		width: $carouselImgLen;

    & img {
      object-fit: contain;
    }
	}
}
</style>



// WEBPACK FOOTER //
// src/components/pages/shared/PartnerSection.vue